import { GET_USER_SUCCESS, GET_USERS_SUCCESS, UPDATE_USER_SUCCESS, LOGIN_SUCCESS, LOGOUT, REGISTER_SUCCESS, SET_PASSWORD_SUCCESS, JOIN_SUCCESS } from '../actions/usersActionTypes';
import { UPDATE_INSTITUTION_SUCCESS } from '../actions/institutionsActionTypes';

const initialState = {
  institution: {
    id: 1,
    name: 'Hospital A',
  },
  roster: {},
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case JOIN_SUCCESS:
    case SET_PASSWORD_SUCCESS:
      return {
        // ...action.token,
        ...state,
        institution: action.institution,
      };
    case LOGOUT:
      return {};
    case REGISTER_SUCCESS:
      return { ...state };
    case GET_USER_SUCCESS:
      return {
        ...state,
        currentUserId: action.user.id,
        roster: {
          ...state.roster,
          [action.user.id]: { ...action.user },
        },
      };
    case UPDATE_INSTITUTION_SUCCESS:
      return {
        ...state,
        institution: action.institution,
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        roster: {
          ...state.roster,
          [action.user.id]: {
            ...state.roster[action.user.id],
            ...action.user,
            notificationPreferences: state.roster[action.user.id].notificationPreferences
              ? {
                ...state.roster[action.user.id].notificationPreferences,
                ...action.user.notificationPreferences,
              } : action.user.notificationPreferences,
          },
        },
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        roster: {
          ...state.roster,
          ...action.users,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/usersReducer.js